<template>
  <div class="fieldset">
    <template v-if="form">
      <h3 class="fieldset-heading">Guardians</h3>

      <!-- Do you want to change any guardians? -->
      <GuardiansYN v-model="form.guardiansYN"/>
      <Guardians v-if="form.guardiansYN" v-model="form.guardians"/>
    </template>
  </div>
</template>

<script>
import {fieldsetHelpers} from "@/components/common/questionnaires/fieldsets/fieldsetHelpers";
import {statusOptions} from "@/components/common/questionnaires/question/options/statusOptions";
import {personalDetails} from "@/components/common/questionnaires/question/options/personalDetails";

import GuardiansYN from "@/components/common/questionnaires/question/questions/amendment/GuardiansYN.vue";
import Guardians from "@/components/common/questionnaires/question/questions/amendment/Guardians.vue";

export default {
  name: 'GuardiansAmendment',
  mixins: [fieldsetHelpers, statusOptions, personalDetails],
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  components: {
    GuardiansYN,
    Guardians,
  },
  data() {
    return {
      label: 'Guardians', // used for steps progress
      videoUrl: null
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        console.log('HERE---b---', this.value);
        return this.value
      }
    }
  }
};
</script>
